import bindAllMethods from '../../utils/bindAllMethods';
import BaseContainer from '../../core/containers/BaseContainer';
import TenantObserver, {
  TenantEvents
} from '../../services/tenantHandler/TenantObserver';
import { internalLogger } from '../../interface/v1/clientOsLogger';

export default class SubscriberRestartTenantServices {
  private _accessControlContainer: BaseContainer;

  constructor({ accessControlContainer }) {
    this._accessControlContainer = accessControlContainer;
    bindAllMethods(this);
  }

  public init = async (): Promise<void> => {
    TenantObserver.subscribe(
      TenantEvents.SET_TENANT_HANDLER_KEY,
      this._initializeContextServices
    );

    TenantObserver.subscribe(
      TenantEvents.SET_TENANT,
      this._refreshContextServices
    );
  };

  public async _initializeContextServices(): Promise<void> {
    internalLogger?.debug?.('Initializing Access Control Containers...');
    await this._accessControlContainer?.initializeContextServices();
  }

  public async _refreshContextServices(): Promise<void> {
    internalLogger?.debug?.('Refreshing Access Control Containers...');
    await this._accessControlContainer?.refreshContext();
  }
}
